// src/pages/SocialLoginLanding.tsx
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ENABLE_KAKAO } from "../config/social";

const API_BASE = (import.meta.env.VITE_API_BASE || "").replace(/\/$/, "");

export default function SocialLoginLanding() {
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get("token");
    const next = params.get("next") || "/";

    // ✅ 현재 소셜 로그인 기능이 모두 꺼져있다면 바로 로그인으로
    // (네이버 제거: 카카오만 기준)
    if (!ENABLE_KAKAO) {
      window.location.replace("/login");
      return;
    }

    // 토큰 없으면 그냥 로그인 페이지로
    if (!token) {
      window.location.replace("/login");
      return;
    }

    // 토큰 저장
    localStorage.setItem("token", token);

    // 토큰 기준으로 /api/me 조회해서 인증 상태 확인
    (async () => {
      try {
        const meUrl = API_BASE ? `${API_BASE}/api/me` : "/api/me";

        const res = await fetch(meUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          window.location.replace("/login");
          return;
        }

        const data: any = await res.json();
        const user = data?.user;

        const ekyc = user?.ekyc_status;
        const account = user?.account_status;

        const hasAnyVerification =
          ekyc === "verified" || account === "verified";

        if (hasAnyVerification) {
          // ✅ next가 있으면 그쪽 우선, 없으면 홈
          window.location.replace(next || "/");
        } else {
          window.location.replace("/onboarding");
        }
      } catch (e) {
        console.error("social-login /api/me error", e);
        window.location.replace("/login");
      }
    })();
  }, [params]);

  return (
    <div className="flex min-h-screen items-center justify-center text-sm text-slate-600">
      소셜 로그인 처리중입니다...
    </div>
  );
}
